import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import gsApi from "../auth/auth";
import { baseURL, getThunkResponse, publicTournamentLeaderboardsURL, silentThunkResponse } from "../app/api";
import { getResponse } from "../helpers/JSONapi";
import { getRouting } from "../helpers/Converters";

export const tournmanetsURL = `${baseURL}/tournaments`;

export const tournaemntsRoute = (nested) => {
  return getRouting(tournmanetsURL, nested);
};


export const leaderboardState =  {
  leaderboards: [],
  TVLeaderboards: [],
  flights: [],
  favoriteTeams: [],
  leaderboard: {},
  notifications: [],
  loading: [],
}

//replace all occurences of template with the name of your new slice
export const leaderboardSlice = createSlice({
  name: "leaderboards",
  initialState: leaderboardState,
  //be sure to export any reducers on line 65
  reducers: {
    setTVLeaderboards: (state, action) => {
      state.TVLeaderboards = action.payload
    },
    setLeaderboard: (state, action) => {
      state.leaderboard = action.payload;
    },
    setFavorites: (state, action) => {
      state.favoriteTeams = action.payload ?? []
    },
    addFavorite: (state, action) => {
      const favorites = [...state.favoriteTeams, action.payload]
      state.favoriteTeams = favorites
      localStorage.setItem("favoriteTeams", JSON.stringify(favorites))
    },
    removeFavorite: (state, action) => {
      const favorites = state.favoriteTeams?.filter?.(t => t !== action.payload)
      state.favoriteTeams = favorites
      localStorage.setItem("favoriteTeams", JSON.stringify(favorites))
    },
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    clearLeaderboards: (state) => {
      state.leaderboards = []
      state.flights = []
      state.leaderboard = {}
    }
  },
  extraReducers: (builder) => {
    getThunkResponse(builder, getPublicLeaderboards, (state, action) => {
      state.leaderboards = action.payload;
      state.TVLeaderboards = action.payload;
    });
    getThunkResponse(builder, getLeaderboards, (state, action) => {
      state.leaderboards = action.payload;
    });
    getThunkResponse(builder, getLeaderboardFlights, (state, action) => {
      state.flights = action.payload;
    });
    silentThunkResponse(builder, getLeaderboard, (state, action) => {
      const leaderboardIndex = state.leaderboards.findIndex?.((l)=>{return l.id === action.payload.id})
      const tvLeaderboardIndex = state.TVLeaderboards.findIndex?.((l)=>{return l.id === action.payload.id})
      const refreshed = action.payload?.refreshedAt
      if(leaderboardIndex >= 0 && state.leaderboards[leaderboardIndex]?.refreshedAt !== refreshed){
        state.leaderboards[leaderboardIndex] = action.payload
      }
      if(tvLeaderboardIndex >= 0 && state.TVLeaderboards[tvLeaderboardIndex]?.refreshedAt !== refreshed){
        state.TVLeaderboards[tvLeaderboardIndex] = action.payload
      }
      if(state.leaderboard?.id === action.payload?.id && state.leaderboard?.refreshedAt !== refreshed){
        state.leaderboard = action.payload
      }
    });
  },
});

export const getPublicLeaderboards = createAsyncThunk(
  `${leaderboardSlice.name}/getPublicLeaderboards`,
  async (tournamentID, thunkAPI) => {
    const response = await getResponse(
      gsApi.get,
      tournaemntsRoute([tournamentID, "public-leaderboards"]),
      {},
      thunkAPI
    );
    return response;
  }
);

export const getLeaderboards = createAsyncThunk(
  `${leaderboardSlice.name}/getLeaderboards`,
  async (tournamentID, thunkAPI) => {
    const response = await getResponse(
      gsApi.get,
      tournaemntsRoute([tournamentID, "leaderboards"]),
      {},
      thunkAPI
    );
    return response;
  }
);

export const getLeaderboardFlights = createAsyncThunk(
  `${leaderboardSlice.name}/getLeaderboardFlights`,
  async (tournamentID, thunkAPI) => {
    const response = await getResponse(
      gsApi.get,
      tournaemntsRoute([tournamentID, "tournament-flights"]),
      {},
      thunkAPI
    );
    return response;
  }
);

export const getLeaderboard = createAsyncThunk(
  `${leaderboardSlice.name}/getLeaderboard`,
  async (leaderboardID, thunkAPI) => {
    const response = await getResponse(
      gsApi.get,
      getRouting(publicTournamentLeaderboardsURL, [leaderboardID]),
      {},
      thunkAPI
    );
    return response;
  }
);

export const {
  setTVLeaderboards,
  setLeaderboard,
  setFavorites,
  addFavorite,
  removeFavorite,
  addNotification,
  clearNotifications,
  clearLeaderboards
} = leaderboardSlice.actions;

//export any selectors needed
export const selectLeaderboards = (state) =>
  state?.[leaderboardSlice.name]?.leaderboards;

export const selectTVLeaderboards = (state) =>
  state?.[leaderboardSlice.name]?.TVLeaderboards;

export const selectFlights = (state) => state?.[leaderboardSlice.name]?.flights;

export const selectLeaderboard = (state) =>
  state?.[leaderboardSlice.name]?.leaderboard;

export const selectFavoriteTeams = (state) => state?.[leaderboardSlice.name]?.favoriteTeams

export const selectNotifications = (state) =>
  state?.[leaderboardSlice.name]?.notifications;

export const selectLoading = (state) => state?.[leaderboardSlice.name]?.loading;

export default leaderboardSlice.reducer;

//ADD reducer to store.js
